import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import Avatar from "../../assets/images/four.png";
import "../../Styles/Profile.css";
import { RiCameraFill } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import Select from "react-select";
import { Form } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { handleErrors, validateImage } from "../../services/dataManager";
import { toast } from "sonner";

import {
  addGameApiInfo,
  addNewGame,
  fetchMiscData,
  getAllProviders,
  getGameById,
  getGameCatsList,
  getGameSubCatById,
  getGameTags,
  updateGame,
  updateGameApiInfo,
  uploadGameFile,
  uploadGameImage,
  uploadGameThumbnail,
} from "../../services/axios/apiManager";
import { baseURL } from "../../services/axios/eps";
import { GameApiValidation, newGameValidationSchema } from "./gameValidations";
import { useFormik } from "formik";
import { format, parseISO } from "date-fns";
import makeAnimated from "react-select/animated";
import { customStyles } from "./customStyles";
import {
  ageGroupList,
  genderList,
  dimensions,
} from "../../services/staticData";
import LoadingSpinner from "../../Components/spinner";
import GameUpload from "./uploadGame";
import GameDetailsView from "./gameDetails";

function ViewGame() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [gameData, setGameData] = useState(null);
  const [isEditing, setIsEditing] = useState(id ? false : true);
  const [tagsList, setTagsList] = useState([]);

  const [languages, setLanguages] = useState([]);
  const animatedComponents = makeAnimated();
  const [gameCats, setGameCats] = useState([]);
  const [gameSubCats, setGameSubCats] = useState([]);
  const [activeTab, setActiveTab] = useState("#basicDetails");
  const [updating, setUpdating] = useState(false);
  const [isGameAdded, setIsGameAdded] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [thmbUrl, setThmbUrl] = useState(null);
  const [providers, setProviders] = useState([]);
  const [gameType, setGameType] = useState("fileBase");
  const [selectedFile, setSelectedFile] = useState(null);

  const handleChangeGameType = (e) => {
    setGameType(e.target.value);
  };

  const makeImageURL = (event) => {
    if (event?.currentTarget?.files?.length) {
      const file = event.currentTarget.files[0];
      if (!validateImage(file)) {
        event.currentTarget.value = "";
        return;
      }
      formik?.setFieldValue("image", file);
      const previewUrl = URL.createObjectURL(file);
      setImageUrl(previewUrl);
    } else {
      formik?.setFieldValue("image", gameData.image);
      setImageUrl(null);
    }
  };

  // // // make selected thumbnail URL
  const makeThumbnailURL = (event) => {
    if (event?.currentTarget?.files?.length) {
      const file = event.currentTarget.files[0];
      if (!validateImage(file)) {
        event.currentTarget.value = "";
        return;
      }
      formik?.setFieldValue("icon", file);
      const previewUrl = URL.createObjectURL(file);
      setThmbUrl(previewUrl);
    } else {
      formik?.setFieldValue("thumbnail", gameData.icon);
      setThmbUrl(null);
    }
  };

  const handleTabChange = (e) => {
    // e.preventDefault(); // Prevent default navigation
    const newTab = e.target.getAttribute("href");
    setActiveTab(newTab);
  };

  const getCategories = async () => {
    const res = await getGameCatsList();
    if (res?.data?.success && res?.data?.data) {
      setGameCats(res?.data?.data);
    } else {
      handleErrors(res, navigate, "Game Categories:");
    }
  };

  const getSubCategories = async (id) => {
    const res = await getGameSubCatById(id);
    if (res?.data?.success && res?.data?.data) {
      setGameSubCats(res?.data?.data);
    } else {
      handleErrors(res, navigate, "Game Sub-Categories:");
    }
  };

  const getGameData = async () => {
    if (id) {
      const res = await getGameById(id);
      if (res?.data?.success && res?.data?.data) {
        setGameData(res?.data?.data);
        const { access_type, category } = res.data.data;
        setGameType(access_type);
        if (category) {
          await getSubCategories(category);
        }
      } else {
        handleErrors(res, navigate, "Game:");
      }
    }
    setLoading(false);
  };

  const fetchProviders = async () => {
    const res = await getAllProviders();
    if (res?.data?.success && res?.data?.data) {
      setProviders(res.data.data);
    }
  };

  const getData = async () => {
    await fetchTags();
    await getCategories();
    await fetchOtherData();
    await getGameData();
    await fetchProviders();
  };

  const fetchOtherData = async () => {
    const res = await fetchMiscData();
    if (res?.data?.data) {
      setLanguages(res.data.data.languages || []);
    }
  };

  const fetchTags = async () => {
    const res = await getGameTags();
    if (res?.data?.success && res?.data?.data) {
      const tagsTempList = res?.data?.data?.map((m) => ({
        label: m.name,
        value: m.id,
      }));
      setTagsList(tagsTempList);
    } else {
      handleErrors(res, navigate, "Game Tags:");
    }
  };

  ////////////////////////////////////Upload Game banner Image
  const uploadImage = async (id, image) => {
    if (imageUrl) {
      const formData = new FormData();
      formData.append("image", image);
      const imageResponse = await uploadGameImage(id, formData);
      if (!imageResponse?.data?.success) {
        handleErrors(imageResponse, navigate, "Upload Image: ");
      }
    }
  };

  ////////////////////////////////////Upload Game Icon
  const uploadIcon = async (id, icon) => {
    if (thmbUrl) {
      const formData = new FormData();
      formData.append("image", icon);
      const imageResponse = await uploadGameThumbnail(id, formData);
      if (!imageResponse?.data?.success) {
        handleErrors(imageResponse, navigate, "Upload Icon: ");
      }
    }
  };

  ////////////////////////////////////Add Game API Info
  const handleSaveApiInfo = async () => {
    const res = await addGameApiInfo(GameAPIFormik.values);
    if (res?.data?.success && res?.data?.data) {
      const { id } = res.data.data;
      return id;
    } else {
      handleErrors(res, navigate, "Game API Info: ");
      return null;
    }
  };

  ////////////////////////////////////Update Game API Info
  const handleUpdateApiInfo = async () => {
    const { id } = gameData.api_data;
    const res = await updateGameApiInfo({ id, ...GameAPIFormik.values });
    if (!res?.data?.success) {
      handleErrors(res, navigate, "Game API Info: ");
    }
  };
  // console.log("selectedFile :", selectedFile);

  /////////////////////////////////Upload Game File
  const handleUploadGameFile = async (gameID) => {
    if (selectedFile) {
      const { provider_id } = formik.values;
      console.log("Provider ID :", provider_id);

      if (provider_id) {
        const formData = new FormData();
        const pName = providers.find((f) => f.id == provider_id).name;
        formData.append("zipFile", selectedFile);
        formData.append("provider", pName);
        try {
          const res = await uploadGameFile(formData);
          if (res?.data?.success && res?.data?.data) {
            return res.data.data;
          } else {
            handleErrors(res, navigate, "Game File: ");
            return null;
          }
        } catch (error) {
          console.error("Upload failed:", error);
          handleErrors(error, navigate, "Game File: ");
          return null;
        }
      }
    }
  };

  // // // // // // // // Formik for Game APIs
  const GameAPIFormik = useFormik({
    initialValues: {
      gameUrl: gameData?.api_data?.gameUrl || "",
      userName: gameData?.api_data?.userName || "",
      password: gameData?.api_data?.password || "",
      token: gameData?.api_data?.token || "",
    },
    enableReinitialize: true,
    validationSchema: GameApiValidation,
    onSubmit: async (values) => {
      try {
        console.log("Game API form submitted");
      } catch (error) {
        toast.error("Something went wrong, please try again!", {
          duration: 2000,
        });
      }
    },
  });

  // // // // // // // // Formik for Game Basic details
  const formik = useFormik({
    initialValues: {
      title: gameData?.title || "",
      mob_web_compatible: gameData?.mob_web_compatible || false,
      category: gameData?.category || "",
      sub_category: gameData?.sub_category || "",
      orientation: gameData?.orientation || "portrait",
      dimensions: gameData?.dimensions || "",
      language: gameData?.language || "",
      tags: gameData?.tags || [],
      age_group: gameData?.age_group || [],
      gender: gameData?.gender || [],
      description: gameData?.description || "",
      status: gameData?.status,
      last_update: gameData?.last_update || null,
      published_date: gameData?.published_date || null,
      icon: gameData?.icon || "",
      image: gameData?.image || "",
      company: gameData?.company || "",
      published_by: gameData?.published_by || "",
      provider_id: gameData?.provider_id || "",
      instructions: gameData?.instructions || "",
      recommended: gameData?.recommended || 0,
      featured: gameData?.featured || 0,
      slug: gameData?.slug || "",
      meta_title: gameData?.meta_title || "",
      meta_description: gameData?.meta_description || "",
      meta_keywords: gameData?.meta_keywords || "",
    },
    enableReinitialize: true,
    validationSchema: newGameValidationSchema,
    onSubmit: async (values) => {
      let idData = {};
      try {
        setUpdating(true);
        if (gameType === "apiBase") {
          const gameApiErrors = await GameAPIFormik.validateForm();
          if (Object.keys(gameApiErrors).length > 0) {
            console.log("Validation errors in API form:", gameApiErrors);
            GameAPIFormik.setTouched(gameApiErrors);
            return;
          }
        }

        // // // if id update every thing
        const { icon, image, ...rest } = values;
        if (id) {
          if (gameType === "apiBase") {
            const { api_id } = gameData;
            if (api_id) {
              await handleUpdateApiInfo(api_id, GameAPIFormik.values);
            } else {
              const newApiId = await handleSaveApiInfo(GameAPIFormik.values);
              idData.newApiId = newApiId;
            }
          } else {
            const fileUrl = await handleUploadGameFile();
            idData.fileUrl = fileUrl;
          }
          const updatedData = {
            id: gameData.id,
            access_type: gameType,
            ...rest,
          };
          if (idData?.fileUrl) {
            updatedData.file_name = idData.fileUrl;
          }
          if (idData.newApiId) {
            updatedData.api_id = idData.newApiId;
          }
          const updateResponse = await updateGame(updatedData);
          if (updateResponse?.data?.success) {
            await uploadImage(gameData.id, image);
            await uploadIcon(gameData.id, icon);
            await getGameData();
            toast.success("Basic details has been updated!", {
              duration: 2000,
            });
            setUpdating(false);
            setIsEditing(false);
          } else {
            handleErrors(updateResponse, navigate, "Update Game: ");
          }
        } else {
          if (gameType === "apiBase") {
            const newApiId = await handleSaveApiInfo(GameAPIFormik.values);
            idData.newApiId = newApiId;
          } else {
            const fileUrl = await handleUploadGameFile();
            idData.fileUrl = fileUrl;
          }
          const newData = {
            access_type: gameType,
            ...rest,
          };
          if (idData?.fileUrl) {
            newData.file_name = idData.fileUrl;
          }
          if (idData.newApiId) {
            newData.api_id = idData.newApiId;
          }
          const addResponse = await addNewGame(newData);
          if (addResponse?.data?.success && addResponse?.data?.data) {
            const { id } = addResponse.data.data;
            await uploadImage(id, image);
            await uploadIcon(id, icon);
            setGameData(addResponse.data.data);
            setIsGameAdded(true);
            toast.success("Game has been added!", { duration: 2000 });
            navigate("/GamingPlatformManagement");
          } else {
            handleErrors(addResponse, navigate, "Add Game: ");
          }
        }
      } catch (error) {
        console.log("Error on saving game data", error);
        toast.error("Something went wrong while saving!", { duration: 2000 });
      } finally {
        setUpdating(false);
      }
    },
  });

  const handleEditButon = async () => {
    setActiveTab("#basicDetails");
    setIsEditing(!isEditing);
  };

  useEffect(() => {
    getData();
  }, []);

  const handleImageClick = () => {
    document.getElementById("imageUploadInput").click();
  };

  const handleThumbClick = () => {
    document.getElementById("thumbUploadInput").click();
  };

  return (
    <DashboardLayout>
      <div>
        <div>
          <div>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center vh-100">
                <LoadingSpinner size={"lg"} />
              </div>
            ) : (
            <div>
              <div className="card overflow-hidden">
                <div className="bg-blend-darken" style={{ minHeight: 200 }}>
                  <img
                    crossOrigin="anonymous"
                    src={
                      imageUrl ||
                      (gameData?.image
                        ? `${baseURL}uploads/file/${gameData.image}`
                        : Avatar)
                    }
                    alt=""
                    className="card-img-top profile-wid-img object-fit-cover"
                    style={{ maxHeight: 400 }}
                  />
                  <div className="position-absolute end-0 top-0 m-3">
                    <input
                      id="imageUploadInput"
                      type="file"
                      accept="image/png, image/jpeg, image/webp"
                      className="profile-img-file-input d-none"
                      onChange={makeImageURL}
                    />
                    {isEditing && (
                      <label
                        // htmlFor="profile-img-file-input"
                        className="profile-photo-edit avatar-xs"
                        style={{ cursor: "pointer" }}
                        onClick={handleImageClick}
                      >
                        <span
                          className="avatar-title rounded-circle bg-light text-body border shadow-sm d-flex align-items-center justify-content-center"
                          style={{
                            width: "35px",
                            height: "35px",
                            border: "2px solid #aaa", // Added border
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                            transition: "0.3s",
                          }}
                        >
                          <RiCameraFill size={18} />
                        </span>
                      </label>
                    )}
                  </div>
                </div>
                <div className="card-body pt-0 mt-[-2rem]">
                  <div className="text-center">
                    <div className="profile-user position-relative d-inline-block mx-auto">
                      <img
                        crossOrigin="anonymous"
                        src={
                          thmbUrl ||
                          (gameData?.icon
                            ? `${baseURL}uploads/file/${gameData.icon}`
                            : "data:image/jpeg;base64,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")
                        }
                        alt=""
                        className="img-fluid center avatar-lg rounded-circle object-fit-cover img-thumbnail user-profile-image border-0"
                        style={{
                          maxHeight: "200px",
                          minHeight: "150px",
                          width: "150px",
                          objectFit: "contain",
                        }}
                      />
                      <div className="avatar-xs p-0 rounded-circle profile-photo-edit position-absolute end-0 bottom-0">
                        <input
                          id="thumbUploadInput"
                          type="file"
                          accept="image/png, image/jpeg, image/webp"
                          className="profile-img-file-input d-none"
                          onChange={makeThumbnailURL}
                        />
                        {isEditing && (
                          <label
                            className="profile-photo-edit avatar-xs"
                            style={{ cursor: "pointer" }}
                            onClick={handleThumbClick}
                          >
                            <span
                              className="avatar-title rounded-circle bg-light text-body border shadow-sm d-flex align-items-center justify-content-center"
                              style={{
                                width: "35px",
                                height: "35px",
                                border: "2px solid #aaa",
                                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                                transition: "0.3s",
                              }}
                            >
                              <RiCameraFill size={18} />
                            </span>
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="mt-3" data-testid="gameTitle">
                      <h5>
                        {gameData?.title || ""}
                        <i className="bi bi-patch-check-fill align-baseline text-info ms-1" />
                      </h5>
                    </div>
                  </div>
                </div>
                <div
                  className="col-xxl-12 card p-4 rounded text-light"
                  style={{ border: "none", background: "#0a1117" }}
                >
                  <div className="d-flex justify-content-between align-items-center flex-wrap">
                    {/* Left Side - Tabs */}
                    <div className="d-flex align-items-center flex-grow-1">
                      <ul
                        className="nav nav-pills arrow-navtabs nav-secondary gap-2"
                        role="tablist"
                      >
                        <li className="nav-item" role="presentation">
                          <a
                            className={`nav-link ${activeTab === "#basicDetails" ? "active" : ""}`}
                            data-bs-toggle="tab"
                            href="#basicDetails"
                            role="tab"
                            aria-selected="true"
                            onClick={handleTabChange}
                          >
                            Basic Details
                          </a>
                        </li>
                        {id && !isEditing && (
                          <li
                            className="nav-item"
                            role="presentation"
                            // key={tab.href}
                          >
                            <a
                              className={`nav-link ${activeTab === "#companyInfo" ? "active" : ""}`}
                              data-bs-toggle="tab"
                              href="#companyInfo"
                              role="tab"
                              aria-selected="true"
                              onClick={handleTabChange}
                            >
                              Game Provider
                            </a>
                          </li>
                        )}
                        {id && !isEditing && (
                          <li
                            className="nav-item"
                            role="presentation"
                            // key={tab.href}
                          >
                            <a
                              className={`nav-link ${activeTab === "#securityPrivacy" ? "active" : ""}`}
                              data-bs-toggle="tab"
                              href="#securityPrivacy"
                              role="tab"
                              aria-selected="true"
                              onClick={handleTabChange}
                            >
                              Other info
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>

                    {/* Right Side - Edit Button */}
                    <div className="container-fluid">
                      {id && !isEditing && (
                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-secondary d-flex align-items-center mx-2"
                            onClick={() => {
                              navigate("/GamingPlatformManagement");
                            }}
                          >
                            Go Back
                          </button>
                          <button
                            className="btn btn-success d-flex align-items-center"
                            onClick={() => handleEditButon()}
                          >
                            <FaRegEdit className="me-1" /> Edit Game Details
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="tab-content mt-4">
                  {/*  */}
                  {isEditing ? (
                    <div>
                      <div className="tab-content">
                        <div
                          className={`tab-pane ${activeTab === "#basicDetails" ? "active" : ""}`}
                          id="basicDetails"
                          role="tabpanel"
                        >
                          <Form
                            onSubmit={formik.handleSubmit}
                            data-testid="game-form"
                            // action=""
                            className="card-header bg-dark text-white card shadow-lg border-0 rounded-2"
                          >
                            <div className="row pb-2">
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="gameName"
                                    className="form-label"
                                  >
                                    Game Name *
                                  </label>
                                  <Form.Control
                                    id="gameName"
                                    type="text"
                                    placeholder="Enter game name"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("title")}
                                    onChange={async (event) => {
                                      const value = event.target.value;
                                      formik.setFieldValue("title", value);
                                      formik.setFieldValue(
                                        "slug",
                                        value
                                          .toLowerCase()
                                          .trim()
                                          .replace(/ /g, "-")
                                          .replace(/[^\w-]+/g, ""),
                                      );
                                    }}
                                    isInvalid={
                                      formik.touched.title &&
                                      !!formik.errors.title
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.title}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="gameSlug"
                                    className="form-label"
                                  >
                                    Game Slug *
                                  </label>
                                  <Form.Control
                                    id="gameSlug"
                                    type="text"
                                    placeholder="Enter game slug"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("slug")}
                                    isInvalid={
                                      formik.touched.slug &&
                                      !!formik.errors.slug
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.slug}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="companyName"
                                    className="form-label"
                                  >
                                    Company *
                                  </label>
                                  <Form.Control
                                    id="companyName"
                                    type="text"
                                    placeholder="Enter company name"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("company")}
                                    isInvalid={
                                      formik.touched.company &&
                                      !!formik.errors.company
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.company}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="publishedBy"
                                    className="form-label"
                                  >
                                    Published By *
                                  </label>
                                  <Form.Control
                                    id="publishedBy"
                                    type="text"
                                    placeholder="Enter published by"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("published_by")}
                                    isInvalid={
                                      formik.touched.published_by &&
                                      !!formik.errors.published_by
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.published_by}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="providerId"
                                    className="form-label"
                                  >
                                    Provider *
                                  </label>
                                  <Form.Select
                                    id="providerId"
                                    type="text"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("provider_id")}
                                    isInvalid={
                                      formik.touched.provider_id &&
                                      !!formik.errors.provider_id
                                    }
                                  >
                                    <option value="">Select Provider</option>
                                    {providers?.map((p) => (
                                      <option key={p.id} value={p.id}>
                                        {p.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.provider_id}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label className="form-label">Status</label>
                                  <select
                                    id="statusSelect"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("status")}
                                  >
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                  </select>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="dimensions"
                                    className="form-label"
                                  >
                                    Dimension *
                                  </label>
                                  <Form.Select
                                    id="dimensions"
                                    type="text"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("dimensions")}
                                    isInvalid={
                                      formik.touched.dimensions &&
                                      !!formik.errors.dimensions
                                    }
                                  >
                                    <option value="">Select dimensions</option>
                                    {dimensions?.map((m) => (
                                      <option key={m} value={m}>
                                        {m}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.dimensions}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="category"
                                    className="form-label"
                                  >
                                    Category *
                                  </label>
                                  <Form.Select
                                    id="category"
                                    type="text"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("category")}
                                    onChange={async (event) => {
                                      formik.setFieldValue(
                                        "category",
                                        event.target.value,
                                      );
                                      formik.setFieldValue("sub_category", "");
                                      await getSubCategories(
                                        event.target.value,
                                      );
                                    }}
                                    isInvalid={
                                      formik.touched.category &&
                                      !!formik.errors.category
                                    }
                                  >
                                    <option value="">select category...</option>
                                    {gameCats?.map((cat) => (
                                      <option key={cat?.id} value={cat?.id}>
                                        {cat?.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.category}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="subCategory"
                                    className="form-label"
                                  >
                                    Sub-Category *
                                  </label>
                                  <Form.Select
                                    id="subCategory"
                                    type="text"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("sub_category")}
                                    isInvalid={
                                      formik.touched.sub_category &&
                                      !!formik.errors.sub_category
                                    }
                                  >
                                    <option value="">
                                      select sub-category...
                                    </option>
                                    {gameSubCats?.map((cat) => (
                                      <option key={cat?.id} value={cat?.id}>
                                        {cat?.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.sub_category}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="orientation"
                                    className="form-label"
                                  >
                                    Orientation *
                                  </label>
                                  <Form.Select
                                    id="orientation"
                                    type="text"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("orientation")}
                                    isInvalid={
                                      formik.touched.orientation &&
                                      !!formik.errors.orientation
                                    }
                                  >
                                    <option value="portrait">Portrait</option>
                                    <option value="landscape">Landscape</option>
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.orientation}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="language"
                                    className="form-label"
                                  >
                                    Language *
                                  </label>
                                  <Form.Select
                                    id="language"
                                    type="text"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("language")}
                                    isInvalid={
                                      formik.touched.language &&
                                      !!formik.errors.language
                                    }
                                  >
                                    <option value="">Select language</option>
                                    {languages?.map((m) => (
                                      <option
                                        key={m.language}
                                        value={m.language}
                                      >
                                        {m.language}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.language}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="statusSelect"
                                    className="form-label"
                                  >
                                    Mobile Web Compatible *
                                  </label>
                                  <Form.Select
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps(
                                      "mob_web_compatible",
                                    )}
                                    isInvalid={
                                      formik.touched.mob_web_compatible &&
                                      !!formik.errors.mob_web_compatible
                                    }
                                  >
                                    <option value={false}>No</option>
                                    <option value={true}>Yes</option>
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.mob_web_compatible}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label className="form-label">
                                    Recommended
                                  </label>
                                  <select
                                    id="recommendedSelect"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("recommended")}
                                  >
                                    <option value="1">Yes</option>
                                    <option value="0">no</option>
                                  </select>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label className="form-label">Featured</label>
                                  <select
                                    id="featuredSelect"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("featured")}
                                  >
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                  </select>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label className="form-label">
                                    Published Date
                                  </label>
                                  <Form.Control
                                    type="date"
                                    className="bg-dark text-light border-light input-placeholder-light"
                                    placeholder="Select Date"
                                    {...formik.getFieldProps("published_date")}
                                    value={
                                      formik.values.published_date
                                        ? format(
                                            parseISO(
                                              formik.values.published_date,
                                            ),
                                            "yyyy-MM-dd",
                                          )
                                        : ""
                                    }
                                    isInvalid={
                                      formik.touched.published_date &&
                                      !!formik.errors.published_date
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.published_date}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label className="form-label">
                                    Last Update
                                  </label>
                                  <Form.Control
                                    type="date"
                                    className="bg-dark text-light border-light input-placeholder-light"
                                    placeholder="Select Date"
                                    {...formik.getFieldProps("last_update")}
                                    value={
                                      formik.values.last_update
                                        ? format(
                                            parseISO(formik.values.last_update),
                                            "yyyy-MM-dd",
                                          )
                                        : ""
                                    }
                                    isInvalid={
                                      formik.touched.last_update &&
                                      !!formik.errors.last_update
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.last_update}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-12">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="genderSelect"
                                    className="form-label"
                                  >
                                    Gender *
                                  </label>
                                  <Select
                                    inputId="genderSelect"
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    isSearchable={false}
                                    isMulti
                                    options={genderList}
                                    styles={customStyles}
                                    value={
                                      genderList.filter((option) =>
                                        formik.values.gender?.includes(
                                          option.value,
                                        ),
                                      ) || []
                                    }
                                    onChange={(selectedOptions) => {
                                      formik.setFieldValue(
                                        "gender",
                                        selectedOptions
                                          ? selectedOptions.map(
                                              (option) => option.value,
                                            )
                                          : [],
                                      );
                                    }}
                                  />
                                  {formik.errors?.gender &&
                                  formik.touched?.gender ? (
                                    <span className="text-danger">
                                      {formik.errors?.gender}
                                    </span>
                                  ) : null}
                                </Form.Group>
                              </div>
                              <div className="col-lg-12">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="ageGroupSelect"
                                    className="form-label"
                                  >
                                    Age Group *
                                  </label>
                                  <Select
                                    inputId="ageGroupSelect"
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    isSearchable={false}
                                    isMulti
                                    options={ageGroupList}
                                    styles={customStyles}
                                    value={
                                      ageGroupList.filter((option) =>
                                        formik.values.age_group?.includes(
                                          option.value.trim(),
                                        ),
                                      ) || []
                                    }
                                    onChange={(selectedOptions) => {
                                      formik.setFieldValue(
                                        "age_group",
                                        selectedOptions
                                          ? selectedOptions.map((option) =>
                                              option.value.trim(),
                                            )
                                          : [],
                                      );
                                    }}
                                  />
                                  {formik.errors?.age_group &&
                                  formik.touched?.age_group ? (
                                    <span className="text-danger">
                                      {formik.errors?.age_group}
                                    </span>
                                  ) : null}
                                </Form.Group>
                              </div>
                              <div className="col-lg-12">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="tagsSelect"
                                    className="form-label"
                                  >
                                    Tags *
                                  </label>
                                  <Select
                                    inputId="tagsSelect"
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    isSearchable={false}
                                    isMulti
                                    options={tagsList}
                                    styles={customStyles}
                                    value={
                                      tagsList.filter((option) =>
                                        formik.values.tags?.includes(
                                          option.value,
                                        ),
                                      ) || []
                                    }
                                    onChange={(selectedOptions) => {
                                      formik.setFieldValue(
                                        "tags",
                                        selectedOptions
                                          ? selectedOptions.map(
                                              (option) => option.value,
                                            )
                                          : [],
                                      );
                                    }}
                                  />
                                  {formik.errors?.tags &&
                                  formik.touched?.tags ? (
                                    <span className="text-danger">
                                      {formik.errors?.tags}
                                    </span>
                                  ) : null}
                                </Form.Group>
                              </div>

                              <div className="col-lg-12">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="description"
                                    className="form-label"
                                  >
                                    Description
                                  </label>
                                  <Form.Control
                                    id="description"
                                    as="textarea"
                                    rows={2}
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("description")}
                                    isInvalid={
                                      formik.touched.description &&
                                      !!formik.errors.description
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.description}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-12">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="instructions"
                                    className="form-label"
                                  >
                                    Instructions
                                  </label>
                                  <Form.Control
                                    id="instructions"
                                    as="textarea"
                                    rows={2}
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("instructions")}
                                    isInvalid={
                                      formik.touched.instructions &&
                                      !!formik.errors.instructions
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.instructions}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              {/* <div className="row pb-2"> */}
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="metaTitle"
                                    className="form-label"
                                  >
                                    Meta Title
                                  </label>
                                  <Form.Control
                                    id="metaTitle"
                                    type="text"
                                    placeholder="Enter Meta Title"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("meta_title")}
                                  />
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="metaDescription"
                                    className="form-label"
                                  >
                                    Meta Description
                                  </label>
                                  <Form.Control
                                    id="metaDescription"
                                    type="text"
                                    placeholder="Enter Meta Description"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps(
                                      "meta_description",
                                    )}
                                  />
                                </Form.Group>
                              </div>
                              {/* </div> */}
                              <div className="col-lg-12">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="metaKeywords"
                                    className="form-label"
                                  >
                                    Meta Keywords(Comma separated)
                                  </label>
                                  <Form.Control
                                    id="metaKeywords"
                                    as="textarea"
                                    rows={2}
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("meta_keywords")}
                                  />
                                </Form.Group>
                              </div>
                              <div className="col-lg-8 mt-10">
                                <div className="row">
                                  <div className="col-lg-3 px-5 pl-5">
                                    <Form.Group>
                                      <Form.Check
                                        type="radio"
                                        label="File Base"
                                        name="sourceType"
                                        value="fileBase"
                                        checked={gameType === "fileBase"}
                                        onChange={handleChangeGameType}
                                        className="w-auto"
                                        id="fileBaseRadio"
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className="col-lg-3 px-5 pl-5">
                                    <Form.Group>
                                      <Form.Check
                                        type="radio"
                                        label="API Base"
                                        name="sourceType"
                                        value="apiBase"
                                        checked={gameType === "apiBase"}
                                        onChange={handleChangeGameType}
                                        className="w-auto"
                                        id="apiBaseRadio"
                                      />
                                    </Form.Group>
                                  </div>
                                </div>
                              </div>
                              {gameType === "fileBase" ? (
                                <div className="col-lg-12 mb-10">
                                  <GameUpload
                                    selectedFile={selectedFile}
                                    setSelectedFile={setSelectedFile}
                                  />
                                </div>
                              ) : (
                                <div className="col-lg-12 my-10">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <Form.Group className="mb-3">
                                        <label
                                          htmlFor="gameUrl"
                                          className="form-label"
                                        >
                                          Game Url
                                        </label>
                                        <Form.Control
                                          id="gameUrl"
                                          type="text"
                                          placeholder="Enter game URL"
                                          className="bg-dark text-light border-light input-placeholder-light form-control"
                                          {...GameAPIFormik.getFieldProps(
                                            "gameUrl",
                                          )}
                                          isInvalid={
                                            GameAPIFormik.touched.gameUrl &&
                                            !!GameAPIFormik.errors.gameUrl
                                          }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {GameAPIFormik.errors.gameUrl}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>

                                    <div className="col-lg-6">
                                      <Form.Group className="mb-3">
                                        <label
                                          htmlFor="userName"
                                          className="form-label"
                                        >
                                          User Name
                                        </label>
                                        <Form.Control
                                          id="userName"
                                          type="text"
                                          placeholder="Enter user name"
                                          className="bg-dark text-light border-light input-placeholder-light form-control"
                                          {...GameAPIFormik.getFieldProps(
                                            "userName",
                                          )}
                                        />
                                      </Form.Group>
                                    </div>

                                    <div className="col-lg-6">
                                      <Form.Group className="mb-3">
                                        <label
                                          htmlFor="password"
                                          className="form-label"
                                        >
                                          Password
                                        </label>
                                        <Form.Control
                                          id="password"
                                          type="text"
                                          placeholder="Enter password"
                                          className="bg-dark text-light border-light input-placeholder-light form-control"
                                          {...GameAPIFormik.getFieldProps(
                                            "password",
                                          )}
                                        />
                                      </Form.Group>
                                    </div>

                                    <div className="col-lg-6">
                                      <Form.Group className="mb-3">
                                        <label
                                          htmlFor="token"
                                          className="form-label"
                                        >
                                          Token
                                        </label>
                                        <Form.Control
                                          id="token"
                                          type="text"
                                          placeholder="Enter token"
                                          className="bg-dark text-light border-light input-placeholder-light form-control"
                                          {...GameAPIFormik.getFieldProps(
                                            "token",
                                          )}
                                        />
                                      </Form.Group>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="container-fluid">
                                <div className="d-flex justify-content-end">
                                  {loading && <LoadingSpinner size={"lg"} />}
                                  {id && isEditing && (
                                    <button
                                      className="btn btn-secondary d-flex align-items-center mx-2"
                                      onClick={() => {
                                        setIsEditing(false);
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  )}
                                  <button
                                    type="submit"
                                    className="btn btn-success d-flex align-items-center gap-2"
                                    disabled={updating}
                                  >
                                    {updating && <LoadingSpinner size="sm" />}
                                    {id
                                      ? "Update Game Details"
                                      : "Add New Game"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Form>
                        </div>
                        <div
                          className={`tab-pane ${activeTab === "#securityPrivacy" ? "active" : ""}`}
                          id="securityPrivacy"
                          role="tabpanel"
                        >
                          <div className="card shadow-lg border-0 rounded-4">
                            <div className="card-header bg-dark text-white">
                              {/* Card Header */}
                              <div className="card-header bg-dark text-white py-3 border-bottom border-secondary">
                                <h5 className="card-title mb-0 fw-bold">
                                  Other Information
                                </h5>
                              </div>

                              <div className="card-body">
                                <div className="row">
                                  <div className="col-lg-6 mb-3">
                                    <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                      <span className="text-secondary fs-6 fw-semibold">
                                        Created By
                                      </span>
                                      <span className="d-block fs-5 fw-medium">
                                        {`${gameData?.game_created_by?.first_name || ""} ${gameData?.game_created_by?.last_name || ""}`}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 mb-3">
                                    <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                      <span className="text-secondary fs-6 fw-semibold">
                                        Updated By
                                      </span>
                                      <span className="d-block fs-5 fw-medium">
                                        {`${gameData?.game_updated_by?.first_name || ""} ${gameData?.game_updated_by?.last_name || ""}`}
                                      </span>
                                    </div>
                                  </div>

                                  <div className="col-lg-6 mb-3">
                                    <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                      <span className="text-secondary fs-6 fw-semibold">
                                        Created At
                                      </span>
                                      <span className="d-block fs-5 fw-medium">
                                        {gameData?.createdAt
                                          ? format(gameData.createdAt, "PP")
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 mb-3">
                                    <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                      <span className="text-secondary fs-6 fw-semibold">
                                        Updated At
                                      </span>
                                      <span className="d-block fs-5 fw-medium">
                                        {gameData?.updatedAt
                                          ? format(gameData.updatedAt, "PP")
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 mb-3">
                                    <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                      <span className="text-secondary fs-6 fw-semibold">
                                        Deleted At
                                      </span>
                                      <span className="d-block fs-5 fw-medium">
                                        {gameData?.deletedAt
                                          ? format(gameData.deletedAt, "PP")
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <GameDetailsView gameData={gameData} />
                  )}
                </div>
              </div>
            </div>
          )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default ViewGame;
